<div>
	<div class="status-container__left">
		<p>This VaxStatus feature has been discontinued and its functionality will no longer be accessible.</p>
	</div>
</div>
